<template>
	<div class="grid">
		<!-- <container className="container-item">
			<a url="../rehistory/rehistory" open-type="a" hover-class="a-hover">
				<div class="item hydropower">
					<img mode="widthFix" src="/c_img/icon-water.png"/>
					<p class="fontSmall">水电缴费</p>
				</div>
			</a>
			<a url="../rehistory/rehistory" open-type="a" hover-class="a-hover">
				<div class="item net">
					<img mode="widthFix" src="/c_img/icon-wang.png"/>
					<p class="fontSmall">网费缴费</p>
				</div>
			</a>
			<a url="../rehistory/rehistory" open-type="a" hover-class="a-hover">
				<div class="item history">
					<img mode="widthFix" src="/c_img/icon-telecom2.png"/>
					<p class="fontSmall">电信缴费</p>
				</div>
			</a>
			<a url="../rehistory/rehistory" open-type="a" hover-class="a-hover">
				<div class="item tel">
					<img mode="widthFix" src="/c_img/icon-tel.png"/>
					<p class="fontSmall">话费充值</p>
				</div>
			</a>
		</container> -->
			<router-link to="/lifepay" ><img src="../../static/images/life.png" alt="">	</router-link>


		<!-- 暂时先写死，有需求再改为PROPS -->


	</div>
</template>

<script>



export default{
	name:"grid"

}

</script>
<style scoped>
img{
	width:100%;
	height: auto;
	objectfill:cover;

}
</style>


// WEBPACK FOOTER //
// src/components/grid.vue